<template>
    <div class="columns">
        <div class="column is-one-third is-offset-one-third">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
}
</script>
